// extracted by mini-css-extract-plugin
module.exports = {"feature":"FeaturedIn_feature__1VXjK","trending":"FeaturedIn_trending__15IRX","trendingMassage":"FeaturedIn_trendingMassage__6ZHSX"};